module.exports = __webpack_public_path__ + "media/tichangsu.c1e08306.mp4";